:host {
  display: inline-block;
  --sc-avatar-size: 3rem;
}
.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: var(--sc-avatar-size);
  height: var(--sc-avatar-size);
  background-color: var(--sc-color-gray-400);
  font-family: var(--sc-font-sans);
  font-size: calc(var(--sc-avatar-size) * 0.5);
  font-weight: var(--sc-font-weight-normal);
  color: var(--sc-color-white);
  user-select: none;
  vertical-align: middle;
}
.avatar--circle,
.avatar--circle .avatar__image {
  border-radius: var(--sc-border-radius-circle);
}
.avatar--rounded,
.avatar--rounded .avatar__image {
  border-radius: var(--sc-border-radius-medium);
}
.avatar--square {
  border-radius: 0;
}
.avatar__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.avatar__initials {
  line-height: 1;
  text-transform: uppercase;
}
.avatar__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
}
